import * as yup from "yup";

const ActivateUserPageValidation = yup.object().shape({
	email: yup
		.string()
		.email("Lütfen geçerli bir e-posta adresi giriniz.")
		.required("E-posta adresi boş bırakılamaz."),
	activationCode: yup.string().required("Lütfen aktivasyon kodunu giriniz."),
});

export default ActivateUserPageValidation;
